<template>
  <input type="text"
         ref="input"
         :placeholder="placeholder"
         :readonly="readonly"
         :maxlength="maxLength"
         v-model="phoneNumber"
  >
</template>

<script>
  import formatInternational from 'common/libs/phone-number/phone-format.js'

  export default {
    name: 'input-phone',
    props: {
      readonly: {
        type: String
      },
      value: {
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      maxLength: {
        type: Number,
        default: function () {
          return 13
        }
      }
    },
    data: function () {
      return {
        phoneNumber: ''
      }
    },
    watch: {
      value: function (val) {
        this.phoneNumber = this.value
      },
      phoneNumber: function (val) {
        this.formatValue()
        this.$emit('input', this.phoneNumber)
      }
    },
    methods: {
      formatValue: function () {
        this.phoneNumber = formatInternational('KR', this.phoneNumber)
      }
    },
    mounted: function () {
      this.phoneNumber = this.value
      this.formatValue()
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// ../common/components/InputPhone.vue